
// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Mobile menu
$(document).mouseup(function(e)
{
    var container = $('.sidenav');
    var openNav;
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0 && $('body').hasClass('mobile-menu-active'))
    {
        openNav();
    }

    $('.menu-toggler').click(function(){
        openNav();
    });
});

$(document).ready(function () {

    var $menuItems = $( '#menu-primary' ).html();
    var $subSitesMenu = $( '#sub-sites-menu' ).html();

    var $menu = '<div class="sidenav">\n' +
        '          <div class="sidenav-panels">\n' +
        '            <div class="sidenav-panel" id="panel-menu">\n' +
        '             <div class="sidenav-panel-label">Menu</div>\n' +
        '               <ul>' + $menuItems + '</ul>\n' +
        '            </div>\n' +
        '            <div class="c-sub-sites-menu">\n' +
        '               <ul>' + $subSitesMenu + '</ul>\n' +
        '            </div>\n' +
        '          </div>\n' +
        '        </div>';

    $($menu).appendTo( 'body' );

    $('#panel-menu > ul > li > a').click(function(){
        $('body').removeClass('mobile-menu-active');
        $('.menu-toggler').toggleClass('menu-toggler--open');
    });

    $('#panel-menu > ul > li.menu-item-has-children').each(function(index){
        $(this).find('> a').after('<span class="custom-arrow"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" class="svg-inline--fa fa-arrow-right fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path></svg></span>');
        $(this).find('.custom-arrow').click(function(){
            $('#panel-'+index).addClass('sidenav-panel_open');
        });
        $('.sidenav-panel-sub').find('ul li.menu-item-has-children').each(function(index1,value2){
            $(value2).find('.custom-arrow').click(function(){
                $('#panel-sub-'+index1).addClass('sidenav-panel_open');
            });
        });
    });

    $('.backbtn').click(function(){
        $(this).parents('.sidenav-panel').toggleClass('sidenav-panel_open');
    });
    // Submenu
    $('#panel-menu > ul > li.menu-item-has-children').each(function(index,value){

        var itemName = $(this).find('> a').text();
        var subItems = $(value).find('.sub-menu').html();

        var panel = '<div id="panel-'+ index +'" class="sidenav-panel sidenav-panel-sub"><a href="javascript:void(0)" class="backbtn"><span class="custom-arrow"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" class="svg-inline--fa fa-arrow-right fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path></svg>Terug</span></a><div class="sidenav-panel-label">'+ itemName +'</div><ul>'+ subItems +'</ul></div>';
        $('.sidenav-panels').append(panel);

        $(this).find('.custom-arrow').click(function(){
            $('#panel-'+index).addClass('sidenav-panel_open');
        });

        // Subsubmenu
        $('.sidenav-panel-sub').find('ul li.menu-item-has-children').each(function(index1,value2){
            var subItemName = $(this).find('> a').text();
            var subsubItems = $(value2).find('.sub-menu').html();

            var panel2 = '<div id="panel-sub-'+ index1 +'" class="sidenav-panel sidenav-panel-sub-sub"><a href="javascript:void(0)" class="backbtn"><span class="custom-arrow"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" class="svg-inline--fa fa-arrow-right fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path></svg>Terug</span></a><div class="sidenav-panel-label">'+ subItemName +'</div><ul>'+ subsubItems +'</ul></div>';
            $('.sidenav-panels').append(panel2);

            $(value2).find('.custom-arrow').click(function(){
                $('#panel-sub-'+index1).addClass('sidenav-panel_open');
            });
        });
    });

    $('.backbtn').click(function(){
        $(this).parents('.sidenav-panel').toggleClass('sidenav-panel_open');
    });

    $('.menu-toggler').click(function(){
        $('body').toggleClass('mobile-menu-active');
        $('.menu-toggler').toggleClass('menu-toggler--open');
    });

    $('.closebtn').click(function(){
        $('body').toggleClass('mobile-menu-active');
        $('.menu-toggler').toggleClass('menu-toggler--open');
    });

    goBack ()

    function goBack() {
        $('.sidenav-panel').removeClass('sidenav-panel_open');
    }
});

// Sticky header
var navbar = $('#navbar');
var header = $('.c-header');
var topbar = $('.c-topbar');

navbar.removeClass('sticky');

$(window).scroll(function () {

    if (navbar !== undefined && navbar !== null) {

        // console.log(topbar.height())
        if (topbar.innerHeight()) {
            if (window.pageYOffset >= topbar.innerHeight()) {

                // navbar.addClass("sticky")
                header.addClass('header--fixed')
            } else {
                // navbar.removeClass("sticky");
                header.removeClass('header--fixed')
            }
        } else {
            if (window.pageYOffset >= 0) {

                // navbar.addClass("sticky")
                header.addClass('header--fixed')
            } else {
                // navbar.removeClass("sticky");
                header.removeClass('header--fixed')
            }
        }
    }
});

// Flexslider
$(window).load(function() {
    $('.flexslider').flexslider();
});

// Subswitch in header
$(document).ready(function () {
    $('.sub-switch').on('click', function() {
        $('.sub-switch--content').toggle();
    });
});

$(function(){
  'use strict';

  $('button.search').on( 'click', function() {
    $('.search-popup').addClass('visible');
  });

  $('.search-popup .btn-close').on( 'click', function() {
    $('.search-popup').removeClass('visible');
  });

  $(document).keyup(function(e) {
    if (e.key === 'Escape') { // escape key maps to keycode `27`
      $('.search-popup').removeClass('visible');
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js